import { subAdminConstants } from "../constants/subAdminConstants";

const initialState = {
  sending: false,
  subAdminResponse: {},
  userList: {},
  deletedUser: {},
  updatedUser: {},
  userDetails: {},
  store:{},
  storeCredit:{},
  permissionList: [],
  aclSetting: [],
  error: null
};

export default function subAdminReducer(state = initialState, action) {
  switch (action.type) {
    case subAdminConstants.ADD_SUBADMIN_REQUEST:
      return {
        sending: true
      };
    case subAdminConstants.ADD_SUBADMIN_SUCCESS:
      return {
        ...state,
        subAdminResponse: action.data
      };
    case subAdminConstants.ADD_SUBADMIN_FAILURE:
      return {
        ...state,
        error: action.error
      };
    case subAdminConstants.GET_USERLIST_REQUEST:
      return {
        sending: true
      };
    case subAdminConstants.GET_USERLIST_SUCCESS:
      return {
        ...state,
        userList: action.data
      };
    case subAdminConstants.GET_USERLIST_FAILURE:
      return {
        ...state,
        error: action.error
      };
    case subAdminConstants.GET_PERMISSIONLIST_REQUEST:
      return {
        sending: true
      };
    case subAdminConstants.GET_PERMISSIONLIST_SUCCESS:
      return {
        sending: false,
        permissionList: action.data
      };
    case subAdminConstants.GET_PERMISSIONLIST_FAILURE:
      return {
        sending: false,
        error: action.error
      };
    case subAdminConstants.SAVE_PERMISSION_REQUEST:
      return {
        sending: true
      };
    case subAdminConstants.SAVE_PERMISSION_SUCCESS:
      return {
        sending: false,
        aclSetting: action.data
      };
    case subAdminConstants.SAVE_PERMISSION_FAILURE:
      return {
        sending: false,
        error: action.error
      };
    case subAdminConstants.DELETE_USER_REQUEST:
      return {
        sending: true
      };
    case subAdminConstants.DELETE_USER_SUCCESS:
      return {
        ...state,
        deletedUser: action.data
      };
    case subAdminConstants.DELETE_USER_FAILURE:
      return {
        ...state,
        error: action.error
      };
    case subAdminConstants.UPDATE_USER_REQUEST:
      return {
        sending: true
      };
    case subAdminConstants.UPDATE_USER_SUCCESS:
      return {
        ...state,
        updatedUser: action.data
      };
    case subAdminConstants.UPDATE_USER_FAILURE:
      return {
        ...state,
        error: action.error
      };
    case subAdminConstants.GET_USER_DETAILS_REQUEST:
      return {
        sending: true
      };
    case subAdminConstants.GET_USER_DETAILS_SUCCESS:
      return {
        ...state,
        userDetails: action.data
      };
    case subAdminConstants.GET_USER_DETAILS_FAILURE:
      return {
        ...state,
        error: action.error
      };
    case subAdminConstants.POST_STORE_CREDIT_REQUEST:
      return {
        sending: true
      };
    case subAdminConstants.POST_STORE_CREDIT_SUCCESS:
      return {
        ...state,
        store: action.data
      };
    case subAdminConstants.POST_STORE_CREDIT_FAILURE:
      return {
        ...state,
        error: action.error
      };
    case subAdminConstants.GET_STORE_CREDIT_REQUEST:
      return {
        sending: true
      };
    case subAdminConstants.GET_STORE_CREDIT_SUCCESS:
      return {
        ...state,
        storeCredit: action.data
      };
    case subAdminConstants.GET_STORE_CREDIT_FAILURE:
      return {
        ...state,
        error: action.error
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/app/redux/reducers/subAdminReducer.js